import { z } from 'zod';

export const ReinstateExamEventExamineeFormSchema = z.object({
  reason: z
    .string()
    .trim()
    .min(1, { message: 'กรุณาระบุสาเหตุ' })
    .max(255, { message: 'ความยาวต้องไม่เกิน 255 ตัวอักษร' }),
});

export type ReinstateExamEventExamineeFormInput = z.infer<
  typeof ReinstateExamEventExamineeFormSchema
>;
